import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";
import { initMixpanel } from "./lib/mixpanel";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Capture beforeinstallprompt early — Chrome can fire this before React mounts.
// WebAppPWAControls reads window.__deferredPWAInstallPrompt on mount.
window.__deferredPWAInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredPWAInstallPrompt = e;
});
// Persist install state at the window level — survives React unmount/remount
// (Chrome may reload the page as part of a PWA install).
window.addEventListener("appinstalled", () => {
  try {
    localStorage.setItem("zt_pwa_installed", "true");
    localStorage.setItem("zt_pwa_installed_at", String(Date.now()));
  } catch {}
  window.__deferredPWAInstallPrompt = null;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
initMixpanel();
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <GoogleOAuthProvider clientId={clientId}>
        <Provider store={store}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Provider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
